import {
  createSlice,
} from "@reduxjs/toolkit";
import { Reducer } from "./Reducer";
import { ExtractModes, ICreateExtractState } from "./Types";

export const fieldValue = {
  value: "",
  valid: false,
  errorText: "",
};

export const initialExtract = {
  title: fieldValue,
  schema: fieldValue,
  survey: fieldValue,
  isActive: false,
  financialYear: "",
  description: ""
};

export const initialState: ICreateExtractState = {
  newExtract: initialExtract,
  savedExtract: null,
  mode: ExtractModes.CREATE,
  editExtractDetail: initialExtract,
  editPreviousExtractDetail: initialExtract,
  isDetailsUpdated: false
};

export const Slice = createSlice({
  name: "extract-add-reducer",
  initialState,
  reducers: Reducer,
});

export const { setNewExtract } = Slice.actions;
